import { cn } from '../../lib/cn';
import IconLabelFactory from './IconLabelFactory';

/**
 * BrandLogo — IGNODE Label Factory glyph. Same gradient-square pattern as
 * Agent Builder's Bot icon container, with Label Factory's bbox+tag SVG.
 *
 *   from-primary-600 to-primary-600 rounded-xl (matches Agent Builder TopNavbar)
 */
interface BrandLogoProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const SIZE = {
    sm: { box: 'w-8 h-8', icon: 'h-4 w-4' },
    md: { box: 'w-10 h-10', icon: 'h-5 w-5' },
    lg: { box: 'w-14 h-14', icon: 'h-7 w-7' },
};

export default function BrandLogo({ size = 'md', className }: BrandLogoProps) {
    const s = SIZE[size];
    return (
        <div
            className={cn(
                'shrink-0 rounded-xl flex items-center justify-center text-white shadow-lg',
                'bg-gradient-to-br from-primary-600 to-primary-600 shadow-primary-500/30',
                s.box,
                className,
            )}
        >
            <IconLabelFactory className={s.icon} />
        </div>
    );
}
